import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r3
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass,
  __glob
} from "./chunk.2QRLEY22.js";

// src/components/jb-svg/jb-svg.scss?inline
var jb_svg_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
span {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

span {
  font-size: var(--theme-typo-uppercase-700-fontsize, 0.688rem);
  letter-spacing: var(--theme-typo-uppercase-700-letterspacing, 0.063rem);
  line-height: var(--theme-typo-uppercase-700-lineheight, 1rem);
  text-transform: uppercase;
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  color: inherit;
  display: inline;
  font: inherit;
}

div {
  align-items: center;
  display: flex;
  gap: var(--spacing-3xs);
  justify-content: center;
  width: fit-content;
}
div.row {
  flex-direction: row;
}
div.row-reverse {
  flex-direction: row-reverse;
}
div.column {
  flex-direction: column;
}
div.column-reverse {
  flex-direction: column-reverse;
}
div.expand.hovered, div.expand:hover {
  --_svg-transform-value: var(--svg-transform-value, 1.125);
  --svg-transform: scale(var(--_svg-transform-value));
}
div.move_right.hovered, div.move_right:hover {
  --_svg-transform-value: var(--svg-transform-value, 0.125rem);
  --svg-transform: translateX(var(--_svg-transform-value));
}
div.move_left.hovered, div.move_left:hover {
  --_svg-transform-value: var(--svg-transform-value, -0.125rem);
  --svg-transform: translateX(var(--_svg-transform-value));
}
div.move_up.hovered, div.move_up:hover {
  --_svg-transform-value: var(--svg-transform-value, -0.125rem);
  --svg-transform: translateY(var(--_svg-transform-value));
}
div.move_down.hovered, div.move_down:hover {
  --_svg-transform-value: var(--svg-transform-value, 0.125rem);
  --svg-transform: translateY(var(--_svg-transform-value));
}
div.tilt.hovered, div.tilt:hover {
  --_svg-transform-value: var(--svg-transform-value, 15deg);
  --svg-transform: rotate(var(--_svg-transform-value));
}
div.rotate.hovered, div.rotate:hover {
  --_svg-transform-value: var(--svg-transform-value, 90deg);
  --svg-transform: rotate(var(--_svg-transform-value));
}

svg {
  height: var(--icon-height, 18px);
  transform: var(--svg-transform);
  transition: transform 0.3s ease-out 0s;
  width: var(--icon-width, 18px);
  will-change: transform;
}

span {
  min-width: fit-content;
}`;

// import("./icons/**/*.svg.ts") in src/components/jb-svg/jb-svg.ts
var globImport_icons_svg_ts = __glob({
  "./icons/ARROW_DOWN.svg.ts": () => import("../components/jb-svg/icons/ARROW_DOWN.svg.js"),
  "./icons/ARROW_LEFT.svg.ts": () => import("../components/jb-svg/icons/ARROW_LEFT.svg.js"),
  "./icons/ARROW_RIGHT.svg.ts": () => import("../components/jb-svg/icons/ARROW_RIGHT.svg.js"),
  "./icons/ARROW_UP.svg.ts": () => import("../components/jb-svg/icons/ARROW_UP.svg.js"),
  "./icons/CHEVRON.svg.ts": () => import("../components/jb-svg/icons/CHEVRON.svg.js"),
  "./icons/DOWNLOAD.svg.ts": () => import("../components/jb-svg/icons/DOWNLOAD.svg.js"),
  "./icons/EMAIL_TEMPLATE.svg.ts": () => import("../components/jb-svg/icons/EMAIL_TEMPLATE.svg.js"),
  "./icons/EXTERNAL.svg.ts": () => import("../components/jb-svg/icons/EXTERNAL.svg.js"),
  "./icons/FILE.svg.ts": () => import("../components/jb-svg/icons/FILE.svg.js"),
  "./icons/FILE_EXCEL.svg.ts": () => import("../components/jb-svg/icons/FILE_EXCEL.svg.js"),
  "./icons/FILE_PDF.svg.ts": () => import("../components/jb-svg/icons/FILE_PDF.svg.js"),
  "./icons/FILE_POWERPOINT.svg.ts": () => import("../components/jb-svg/icons/FILE_POWERPOINT.svg.js"),
  "./icons/FILE_WORD.svg.ts": () => import("../components/jb-svg/icons/FILE_WORD.svg.js"),
  "./icons/INTERNAL.svg.ts": () => import("../components/jb-svg/icons/INTERNAL.svg.js"),
  "./icons/IN_PAGE.svg.ts": () => import("../components/jb-svg/icons/IN_PAGE.svg.js"),
  "./icons/MAIL.svg.ts": () => import("../components/jb-svg/icons/MAIL.svg.js"),
  "./icons/NEWS.svg.ts": () => import("../components/jb-svg/icons/NEWS.svg.js"),
  "./icons/POLICIES.svg.ts": () => import("../components/jb-svg/icons/POLICIES.svg.js"),
  "./icons/SHAREPOINT_PAGE.svg.ts": () => import("../components/jb-svg/icons/SHAREPOINT_PAGE.svg.js"),
  "./icons/WEB_PAGE.svg.ts": () => import("../components/jb-svg/icons/WEB_PAGE.svg.js")
});

// src/components/jb-svg/jb-svg.ts
var JbSVG = class extends r2 {
  constructor() {
    super(...arguments);
    this.animation = "NONE";
    this.flexDirection = "row";
    this.hovered = false;
    this._loadedSVG = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this._loadSVG();
  }
  shouldUpdate(changedProperties) {
    if (changedProperties.has("path") || changedProperties.has("icon")) this._loadSVG();
    return super.shouldUpdate(changedProperties);
  }
  /** Returns for example arrow_right from "/icons/ARROW_RIGHT.svg"  */
  _getIconNameFromPath() {
    return this.path?.split("/").pop().replace(".svg", "").toLowerCase() || "";
  }
  /** Sets _loadedSVG by fetching the svg from a given path or icon name */
  _loadSVG() {
    const handle = async () => {
      if (this.path)
        this._loadedSVG = await fetch(this.path).then((res) => res.text()).then((res) => ae(res));
      else if (this.icon) this._loadedSVG = await globImport_icons_svg_ts(`./icons/${this.icon}.svg.ts`).then((res) => res.default);
      else throw new Error("No path or icon provided");
    };
    const promise = new Promise((resolve) => {
      handle().then(() => {
        resolve({ status: "success", svg: this._loadedSVG, path: this.path, icon: this.icon });
      });
    });
    this.dispatchEvent(new CustomEvent("svg-loading", { detail: promise }));
  }
  render() {
    return ke`
      <div
        part="svg"
        class="${Rt({
      [this._getIconNameFromPath()]: true,
      [this.animation?.toLowerCase()]: !!this.animation,
      hovered: this.hovered,
      [this.flexDirection]: true
    })}"
      >
        <!-- Render the svg once it's loaded -->
        ${this._loadedSVG && this._loadedSVG}

        <!-- A slot, that can also be set via property "text" -->
        ${this.text ? ke`<span>${this.text}</span>` : ke`<slot></slot>`}
      </div>
    `;
  }
};
JbSVG.styles = r(jb_svg_default);
__decorateClass([
  n()
], JbSVG.prototype, "animation", 2);
__decorateClass([
  n()
], JbSVG.prototype, "flexDirection", 2);
__decorateClass([
  n({ type: Boolean })
], JbSVG.prototype, "hovered", 2);
__decorateClass([
  n()
], JbSVG.prototype, "icon", 2);
__decorateClass([
  n()
], JbSVG.prototype, "path", 2);
__decorateClass([
  n()
], JbSVG.prototype, "text", 2);
__decorateClass([
  r3()
], JbSVG.prototype, "_loadedSVG", 2);
JbSVG = __decorateClass([
  customElement("jb-svg")
], JbSVG);

export {
  JbSVG
};
